<template>
  <!-- 截屏按钮 -->
  <a-tooltip placement="leftTop" arrow-point-at-center>
    <template #title>
      <span>发送反馈</span>
    </template>
    <button class="send-feedback" @click="showModal"><form-outlined /></button>
  </a-tooltip>

  <!-- 截屏组件模态框 -->
  <a-modal
    v-model:visible="visible"
    title="发送反馈"
    @ok="handleOk"
    :afterClose="initModal"
    :maskClosable="false"
    :keyboard="false"
  >
    <a-form
      ref="form"
      name="basic"
      :model="formState"
      :label-col="{ span: 4 }"
      :wrapper-col="{ span: 20 }"
      autocomplete="off"
      :rules="formRules"
    >
      <a-form-item label="联系我们" name="type">
        <div class="contact-us">
          <div class="contact-us-method">
            <img src=http://36.150.110.246:8091/pic/famousbuild1.jpg width=120
            id="refreshImage" style="cursor:pointer;"
            onclick="document.getElementById('refreshImage').src =
            document.getElementById('refreshImage').src + '?' + new
            Date().getTime();"/>
            <div>微信群</div>
          </div>
          <div class="contact-us-method">
            <img src=http://36.150.110.246:8091/pic/famousbuild2.jpg width=120
            />
            <div>公众号</div>
          </div>
        </div>
      </a-form-item>
      <a-form-item label="类型" name="type">
        <a-radio-group v-model:value="formState.type">
          <a-radio value="1">需求</a-radio>
          <a-radio value="2">缺陷</a-radio>
        </a-radio-group>
      </a-form-item>

      <a-form-item label="标题" name="title">
        <a-input v-model:value="formState.title" placeholder="请输入标题" />
      </a-form-item>

      <a-form-item label="描述" name="description">
        <a-textarea
          v-model:value="formState.description"
          placeholder="请详细描述你的问题"
          :rows="4"
        />
      </a-form-item>

      <a-form-item label="邮箱地址" name="contact">
        <a-input
          v-model:value="formState.contact"
          placeholder="请输入邮箱地址"
        />
      </a-form-item>
    </a-form>
    <div>
      <div v-if="!formState.imageUrl">
        <PictureOutlined />
        <a :style="{ 'margin-left': '8px' }" @click="capture">生成截图</a>
      </div>
      <template v-else>
        <a-image :width="150" :src="formState.imageUrl" />
        <a-button
          type="primary"
          size="small"
          danger
          :style="{ 'margin-left': '8px' }"
          @click="deleteImage"
          >删除</a-button
        >
      </template>
    </div>
  </a-modal>

  <!-- 截图组件图片切割区域 -->
  <div id="cut-image-box" class="cut-image-box" v-if="isShowImage">
    <vue-cropper
      ref="cropperRef"
      :options="cropperOptions"
      :src="canvasbase64"
    />
    <div class="cropper-btn">
      <a-button @click="handleCropImage" :style="{ 'margin-right': '10px' }"
        >取消</a-button
      >
      <a-button type="primary" @click="cropImage">确定</a-button>
    </div>
  </div>
</template>

<script>
import { ref, reactive, getCurrentInstance, onMounted } from "vue";
import html2canvas from "html2canvas";
import "cropperjs/dist/cropper.css";
import VueCropper from "vue-cropperjs";
import { validateMobileNumber, validateEmail } from "@/utils/utils";
import { postAction } from "@/server/request/service";
import { useMain } from "@/store/index";
export default {
  name: "Screenshot",
  props: {
    tabsiframe: {
      type: Object,
      default: {}
    },
  },
  components: {
    VueCropper,
  },
  setup(props) {
    const { $message, $bus } = getCurrentInstance().appContext.config.globalProperties;
    const useStoreMain = useMain();
    const visible = ref(false);
    const form = ref(null);
    const formState = reactive({
      type: 1,
      title: "",
      description: "",
      imageUrl: "",
      contact: "",
      userId: "",
      userName: "",
    });

    // 规则
    let validateContact = async (_rule, value) => {
      return new Promise((resolve, reject) => {
        if (value) {
          let isPassEmail = validateEmail(value);
          if (!isPassEmail) {
            reject(new Error("请输入正确的邮箱地址！"));
          } else {
            resolve();
          }
        } else {
          resolve();
        }
      });
    };
    const formRules = {
      type: [{ required: true, message: "请选择类型!" }],
      title: [{ required: true, message: "请输入标题!" }],
      contact: [
        { required: true, message: "请输入邮箱地址!", trigger: "blur" },
        { validator: validateContact, trigger: "blur" },
      ],
    };

    const isShowImage = ref(false);
    const canvasbase64 = ref("");
    const cropperRef = ref(null);
    const cropperOptions = reactive({
      aspectRatio: 1, // 裁剪框的宽高比例
      viewMode: 1, // 裁剪框的显示模式
    });

    const showModal = () => {
      // 判断用户是否登录
      console.log(useStoreMain.userInfo);
      if (Object.keys(useStoreMain.userInfo).length > 0) {
        formState.type = "1";
        formState.title = "";
        formState.description = "";
        formState.imageUrl = "";
        formState.userId = useStoreMain.userInfo.id;
        formState.userName = useStoreMain.userInfo.userName;
        formState.contact = useStoreMain.userInfo.email;
        visible.value = true;
      } else {
        $message.warning("请先登录");
      }
    };

    onMounted(() => {
      $bus.on("openFeedback", () => {
        console.log("接收到值");
        if (!visible.value) {
          showModal();
        }
      });
    });

    const initModal = () => {
      // 判断是截图还是关闭
      // captureScreenshot();
    };

    // 保存反馈信息
    const handleOk = () => {
      form.value
        .validateFields()
        .then((values) => {
          console.log(values);
          console.log(formState);
          postAction("sys/feedBack/save", formState)
            .then((res) => {
              console.log(res);
              if (res.success) {
                visible.value = false;
                $message.success("反馈成功");
              } else {
                $message.warning("反馈失败,请直接联系网站管理员");
              }
            })
            .finally(() => {
              // visible.value = false;
            });
        })
        .catch((error) => {
          console.error(error);
        });
    };

    const capture = () => {
      visible.value = false;
      setTimeout(() => {
        captureScreenshot();
      }, 0);
    };

    // 开始截图
    async function captureScreenshot() {
      // 截取主页面
      const mainCanvas = await html2canvas(document.body);
      // 截取iframe页面
      const iframeElement = document.querySelector("#myFrame");
      const iframeCanvas = await html2canvas(
        iframeElement.contentDocument.body
      );
      combineCanvases(mainCanvas, iframeCanvas, iframeElement);
    }
    // 合并主页面和iframe页面
    function combineCanvases(mainCanvas, iframeCanvas, iframeElement) {
      const canvas = document.createElement("canvas");
      const context = canvas.getContext("2d");

      const mainRect = mainCanvas.getBoundingClientRect();
      const iframeRect = iframeElement.getBoundingClientRect();

      const mainWidth = mainCanvas.width;
      const mainHeight = mainCanvas.height;
      const iframeWidth = iframeCanvas.width;
      const iframeHeight = iframeCanvas.height;

      // 计算 iframe 在主页面中的位置和尺寸，并考虑文档滚动的偏移量
      const iframeOffsetLeft = iframeRect.left + 130;
      const iframeOffsetTop = iframeRect.top + 78;

      // 设置合并后的 Canvas 的尺寸为绘制的图像的实际尺寸
      canvas.width = mainWidth;
      canvas.height = mainHeight;

      console.log("主页面：", mainCanvas, 0, 0, mainWidth, mainHeight);
      context.drawImage(mainCanvas, 0, 0, mainWidth, mainHeight);

      console.log(
        "iframe页面：",
        iframeCanvas,
        iframeOffsetLeft,
        iframeOffsetTop,
        iframeWidth,
        iframeHeight
      );
      context.drawImage(
        iframeCanvas,
        iframeOffsetLeft,
        iframeOffsetTop,
        iframeWidth,
        iframeHeight
      );

      // 输出结果到页面中
      const imageData = canvas.toDataURL("image/png");
      isShowImage.value = true;
      canvasbase64.value = imageData;
    }

    function cropBase64Image(base64Data, x, y, width, height) {
      return new Promise((resolve, reject) => {
        const image = new Image();
        image.onload = () => {
          const canvas = document.createElement("canvas");
          canvas.width = width;
          canvas.height = height;
          const context = canvas.getContext("2d");
          context.drawImage(image, x, y, width, height, 0, 0, width, height);
          const croppedBase64 = canvas.toDataURL("image/png");
          resolve(croppedBase64);
        };
        image.onerror = (error) => {
          reject(error);
        };
        image.src = base64Data;
      });
    }

    // 裁切图片
    const cropImage = () => {
      const cropper = cropperRef.value.cropper;
      console.log(cropperRef);
      const croppedImage = cropper.getCroppedCanvas().toDataURL();
      formState.imageUrl = croppedImage;
      console.log(croppedImage);
      handleCropImage();
    };
    const handleCropImage = () => {
      isShowImage.value = false;
      visible.value = true;
    };

    const deleteImage = () => {
      formState.imageUrl = null;
    };

    return {
      visible,
      form,
      formRules,
      isShowImage,
      canvasbase64,
      cropperRef,
      cropperOptions,
      showModal,
      initModal,
      handleOk,
      formState,
      capture,
      captureScreenshot,
      cropImage,
      handleCropImage,
      deleteImage,
    };
  },
};
</script>

<style lang="less" scoped>
.send-feedback {
  width: 40px;
  height: 40px;
  position: fixed;
  bottom: 8%;
  right: 4%;
  border: none;
  --tw-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0, 0, 0, 0.1) !important;
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color),
    0 1px 2px -1px var(--tw-shadow-color) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000),
    var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
  border-radius: 50%;
  background-color: rgb(0, 0, 0);
  color: #fff;
  transition: transform 0.3s ease-in-out;
}
.send-feedback:hover {
  // background-color: #e8e8e8;
  transform: scale(1.2);
}
.cut-image-box {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.cropper-btn {
  position: absolute;
  bottom: 2%;
  left: 50%;
  transform: translateX(-50%);
}
.contact-us {
  display: flex;
  .contact-us-method {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}
</style>